// extracted by mini-css-extract-plugin
export var contact_form = "contactForm-module--contact_form--a7ee8";
export var contact_form_wrapper = "contactForm-module--contact_form_wrapper--8c752";
export var radios = "contactForm-module--radios--fee15";
export var result = "contactForm-module--result--7c727";